import {
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ComposedChart,
  Line,
  ResponsiveContainer,
} from "recharts";

import ChartWrapper from "./ChartWrapper";

import {
  COLORS,
  LINE_COLOR,
  LINE_STROKE,
  tooltipFormatter,
  tooltipLabelFormatter,
  yaxisFormatter,
} from "../helpers";
import { ALL_CHAIN_CSV_FIELDS } from "../constants";
import { useChartViewState } from "../hooks/useChartViewState";

export default function FeesChart(props) {
  const { data, loading, chartHeight, yaxisWidth } = props;

  const csvFields = [
    { key: "all", name: "Daily Fee" },
    { key: "cumulative", name: "Cumulative Fee" },
  ];

  const { viewState, togglePercentView, formattedData, ...viewSettings } =
    useChartViewState({ data });

  return (
    <ChartWrapper
      title="Fees"
      loading={loading}
      csvFields={csvFields}
      data={formattedData}
      viewState={viewState}
      togglePercentView={togglePercentView}
      description={
        "Collected fees. USD value is calculated with token price at the moment of swap, trade, minting or redeeming KLP"
      }
    >
      <ResponsiveContainer width="100%" height={chartHeight}>
        <ComposedChart data={formattedData}>
          <CartesianGrid strokeDasharray="10 10" />
          <XAxis
            dataKey="timestamp"
            tickFormatter={tooltipLabelFormatter}
            minTickGap={30}
          />

          <YAxis
            dataKey="all"
            interval="preserveStartEnd"
            tickCount={viewState.isPercentsView ? undefined : 7}
            tickFormatter={viewSettings.yaxisTickFormatter}
            width={yaxisWidth}
          />

          <YAxis
            dataKey="cumulative"
            orientation="right"
            yAxisId="right"
            tickFormatter={yaxisFormatter}
            width={yaxisWidth}
          />

          <Tooltip
            formatter={tooltipFormatter}
            labelFormatter={tooltipLabelFormatter}
            contentStyle={{ textAlign: "left" }}
          />
          <Legend />
          {csvFields.slice(0, -1).map((field, index) => (
            <Bar
              key={field.key}
              unit={viewSettings.itemsUnit}
              isAnimationActive={false}
              type="monotone"
              dataKey={field.key}
              stackId={field.key}
              name={field.name}
              fill={COLORS[index]}
            />
          ))}
          <Line
            isAnimationActive={false}
            type="monotone"
            strokeWidth={LINE_STROKE}
            dot={false}
            stroke={LINE_COLOR}
            dataKey="cumulative"
            yAxisId="right"
            name="Cumulative Fee"
          />
        </ComposedChart>
      </ResponsiveContainer>
    </ChartWrapper>
  );
}

export function AllFeesChart({ data, loading, chartHeight, yaxisWidth }) {
  const { viewState, togglePercentView, formattedData, ...viewSettings } =
    useChartViewState({ data });

  return (
    <ChartWrapper
      title="Total Fees"
      loading={loading}
      csvFields={ALL_CHAIN_CSV_FIELDS}
      data={formattedData}
      viewState={viewState}
      togglePercentView={togglePercentView}
    >
      <ResponsiveContainer width="100%" height={chartHeight}>
        <ComposedChart data={formattedData}>
          <CartesianGrid strokeDasharray="10 10" />
          <XAxis
            dataKey="timestamp"
            tickFormatter={tooltipLabelFormatter}
            minTickGap={30}
          />

          <YAxis
            dataKey="all"
            interval="preserveStartEnd"
            tickCount={viewState.isPercentsView ? undefined : 7}
            tickFormatter={viewSettings.yaxisTickFormatter}
            width={yaxisWidth}
          />

          <YAxis
            dataKey="cumulative"
            orientation="right"
            yAxisId="right"
            tickFormatter={yaxisFormatter}
            width={yaxisWidth}
          />

          <Tooltip
            formatter={tooltipFormatter}
            labelFormatter={tooltipLabelFormatter}
            contentStyle={{ textAlign: "left" }}
          />

          <Legend />
          {ALL_CHAIN_CSV_FIELDS.slice(0, -1).map((pair, index) => (
            <Bar
              key={pair.key}
              unit={viewSettings.itemsUnit}
              type="monotone"
              dataKey={pair.key}
              stackId="a"
              name={pair.name}
              fill={COLORS[index]}
              isAnimationActive={false}
            />
          ))}
          <Line
            type="monotone"
            strokeWidth={LINE_STROKE}
            dot={false}
            stroke={LINE_COLOR}
            isAnimationActive={false}
            dataKey="cumulative"
            yAxisId="right"
            name="Cumulative"
          />
        </ComposedChart>
      </ResponsiveContainer>
    </ChartWrapper>
  );
}
